




















import Vue from 'vue'
import UserInput from '@/components/UserInput.vue';

export default Vue.extend({
  name: 'UserConsole',
  components: {
    UserInput
  },
  data () {
    return {
      usernames: [''] as string[],
      commands: [] as string[]
    }
  },
  computed: {
    username(): string {
      return this.usernames.slice(-1)[0];
    },
    slept(): boolean {
      return this.$root.$data.slept();
    }
  },
  methods: {
    submitUsername (username: string) {
      this.usernames.push(username);
      if (username != '') this.commands.push('');
      this.$gtag.event('username');
    },
    execute () {
      this.$root.$data.execute();
    },
    submitCommand (command: string) {
      this.commands.push(command);
      if (this.isShutdownCommand(command)) {
        this.execute();
        setTimeout(() => { this.$router.push({path: '/shutdown/r/now'}); }, 3000);
        this.$gtag.event('shutdown');
      }
    },
    isShutdownCommand (command: string): boolean {
      return command == 'shutdown -r now';
    }
  },
  mounted() {
    if (this.slept) this.$router.push({path: '/neo'});
    this.$gtag.event('console');
  }
});
